import { useState } from 'react';
import { Input } from '../ui/input';
import { toast } from 'sonner';
import StepUpDialog from '../StepUpDialog';
import { wipeDatabase } from '../../services/api';

const PHRASE = 'WIPE ALL DATA';

const WipeDatabaseDialog = ({ open, onOpenChange, onWiped }) => {
  const [phrase, setPhrase] = useState('');

  const handleOpenChange = (o) => { onOpenChange(o); if (!o) setPhrase(''); };

  const confirm = async (requestId, code) => {
    await wipeDatabase(requestId, code);
    toast.success('Database wiped. A full backup was emailed first.');
    onWiped?.();
  };

  return (
    <StepUpDialog
      open={open}
      onOpenChange={handleOpenChange}
      action="wipe"
      targetLabel="entire database"
      title="Wipe Entire Database"
      description={<>Deletes <strong>all vendors, banks, companies, saved filters, schedules and non-Super-Admin users</strong>. A full backup is emailed to the security address first, and the audit log is kept. <strong>This cannot be undone.</strong></>}
      extraReady={phrase === PHRASE}
      extraBody={{ confirmPhrase: phrase }}
      confirmLabel="Wipe Database"
      onConfirm={confirm}
      testIdPrefix="wipe"
    >
      <Input data-testid="wipe-confirm-input" value={phrase} onChange={(e) => setPhrase(e.target.value)} placeholder={`Type ${PHRASE}`} />
    </StepUpDialog>
  );
};

export default WipeDatabaseDialog;
